import { resolveConfigValue } from './config.utils';

export interface MipConfig {
  readonly authorizeURL: string;
  readonly mipClientURL: string;
  readonly logoutURL: string;
  readonly operationModeTimeInSec: number;
}

export interface DatadogConfig {
  readonly applicationId: string;
  readonly clientToken: string;
  readonly environment: string;
  readonly version: string;
}

export interface ProductInfoConfig {
  readonly uiBuildVersion: string;
  readonly apiBuildVersion: string;
}

export interface AppConfig {
  readonly mip: MipConfig;
  readonly datadog: DatadogConfig;
  readonly productInfo: ProductInfoConfig;
}

const getEnvValue = (key: string): unknown => import.meta.env[key];

function loadConfig(): AppConfig {
  return {
    mip: {
      authorizeURL: resolveConfigValue('MIP_AUTHORIZE_URL', 'http://localhost:18400/authorize?returnUrl=', getEnvValue),
      mipClientURL: resolveConfigValue(
        'MIP_CLIENT_URL',
        'https://miptest.materialise.net/identityprovider/main/sessions/materialise.mip.hubclient.js',
        getEnvValue
      ),
      logoutURL: resolveConfigValue('MIP_LOGOUT_URL', 'http://localhost:18400/logout/', getEnvValue),
      operationModeTimeInSec: resolveConfigValue('OPERATION_MODE_TIME_IN_SEC', 10800, getEnvValue)
    },
    datadog: {
      applicationId: resolveConfigValue('DD_APPLICATION_ID', '#', getEnvValue),
      clientToken: resolveConfigValue('DD_CLIENT_TOKEN', '#', getEnvValue),
      environment: resolveConfigValue('DD_APPLICATION_ENVIRONMENT', 'test', getEnvValue),
      version: resolveConfigValue('DD_APPLICATION_VERSION', '0.0.1', getEnvValue)
    },
    productInfo: {
      uiBuildVersion: resolveConfigValue('SERVICE_VERSION', '0.0.0.0'),
      apiBuildVersion: resolveConfigValue('APP_VERSION', '0.0.0.0')
    }
  };
}

export const config: AppConfig = loadConfig();

